export const fruits = [
  {
    id: 'apple',
    name: '苹果',
    alias: '智慧果、平安果',
    season: '秋季',
    origin: '中国、美国',
    image: 'apple.svg',
    nutrition: {
      calories: '52 kcal',
      fiber: '2.4 g',
      vitaminC: '4.6 mg',
      potassium: '107 mg',
    },
    benefits: [
      { category: '护心', description: '富含类黄酮，有助于降低胆固醇和血压。' },
      { category: '改善消化', description: '果胶是良好的膳食纤维，能促进肠道蠕动。' },
      { category: '增强免疫力', description: '富含维生素C和抗氧化剂。' },
    ],
    suitability: {
      suitable: '大部分人群，尤其是心血管疾病患者。',
      unsuitable: '胃酸过多者不宜空腹食用。',
    },
    tips: '连皮吃营养价值更高，但需注意清洗干净。',
  },
  {
    id: 'banana',
    name: '香蕉',
    alias: '快乐水果',
    season: '全年',
    origin: '热带地区',
    image: 'banana.svg',
    nutrition: {
      calories: '89 kcal',
      potassium: '358 mg',
      vitaminB6: '0.4 mg',
      magnesium: '27 mg',
    },
    benefits: [
      { category: '补充能量', description: '富含碳水化合物，是运动员的理想选择。' },
      { category: '调节情绪', description: '含有色氨酸，有助于大脑制造血清素。' },
      { category: '保护心脏', description: '高钾低钠，有助于控制血压。' },
    ],
    suitability: {
      suitable: '运动员、高血压患者、情绪低落者。',
      unsuitable: '肾功能不全者需限制钾的摄入。',
    },
    tips: '未熟透的香蕉含有较多鞣酸，可能引起便秘。',
  },
  {
    id: 'grape',
    name: '葡萄',
    alias: '生命之果',
    season: '夏末秋初',
    origin: '地中海地区',
    image: 'grape.svg',
    nutrition: {
      calories: '69 kcal',
      vitaminK: '14.6 mcg',
      copper: '0.1 mg',
      antioxidants: '白藜芦醇',
    },
    benefits: [
      { category: '抗衰老', description: '葡萄籽和皮中的白藜芦醇是强效抗氧化剂。' },
      { category: '保护视力', description: '有助于保护视网膜，预防黄斑变性。' },
      { category: '护肝', description: '有助于减轻肝脏氧化应激。' },
    ],
    suitability: {
      suitable: '爱美人士、用眼过度者、肝功能欠佳者。',
      unsuitable: '糖尿病患者需适量食用。',
    },
    tips: '不同颜色的葡萄功效略有不同，紫葡萄富含花青素，绿葡萄偏重滋阴。',
  },
  {
    id: 'orange',
    name: '橙子',
    alias: '香橙、甜橙',
    season: '冬季',
    origin: '中国、巴西',
    image: 'orange.svg',
    nutrition: {
      calories: '47 kcal',
      vitaminC: '53.2 mg',
      fiber: '2.4 g',
      potassium: '181 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C，有助于预防感冒。' },
      { category: '美容养颜', description: '抗氧化成分有助于延缓衰老。' },
      { category: '促进消化', description: '膳食纤维丰富，有助于肠道健康。' },
    ],
    suitability: {
      suitable: '大部分人群，尤其是免疫力低下者。',
      unsuitable: '胃溃疡患者不宜多食。',
    },
    tips: '橙皮可泡水饮用，助于消化。',
  },
  {
    id: 'watermelon',
    name: '西瓜',
    alias: '夏日之王',
    season: '夏季',
    origin: '非洲',
    image: 'watermelon.svg',
    nutrition: {
      calories: '30 kcal',
      water: '91%',
      vitaminC: '8.1 mg',
      lycopene: '4532 mcg',
    },
    benefits: [
      { category: '解暑', description: '高含水量，有助于补充水分。' },
      { category: '护心', description: '含有番茄红素，有益心血管健康。' },
      { category: '利尿', description: '有助于促进尿液排出。' },
    ],
    suitability: {
      suitable: '夏季消暑、运动后补水。',
      unsuitable: '糖尿病患者不宜多食。',
    },
    tips: '冰镇后口感更佳，但不宜过量。',
  },
  {
    id: 'pear',
    name: '梨',
    alias: '百果之宗',
    season: '秋季',
    origin: '中国',
    image: 'pear.svg',
    nutrition: {
      calories: '57 kcal',
      fiber: '3.1 g',
      vitaminC: '4.3 mg',
      potassium: '119 mg',
    },
    benefits: [
      { category: '润肺止咳', description: '有助于缓解咳嗽和喉咙干燥。' },
      { category: '促进消化', description: '富含膳食纤维。' },
      { category: '降火', description: '性凉，有助于清热降火。' },
    ],
    suitability: {
      suitable: '咳嗽、上火人群。',
      unsuitable: '脾胃虚寒者不宜多食。',
    },
    tips: '可煮水或炖汤食用，润燥效果更佳。',
  },
  {
    id: 'pineapple',
    name: '菠萝',
    alias: '凤梨',
    season: '春夏',
    origin: '南美洲',
    image: 'pineapple.svg',
    nutrition: {
      calories: '50 kcal',
      vitaminC: '47.8 mg',
      manganese: '0.9 mg',
      bromelain: '丰富',
    },
    benefits: [
      { category: '助消化', description: '含有菠萝蛋白酶，有助于分解蛋白质。' },
      { category: '抗炎', description: '有助于缓解炎症。' },
      { category: '美容养颜', description: '富含维生素C。' },
    ],
    suitability: {
      suitable: '消化不良、炎症人群。',
      unsuitable: '过敏体质者慎食。',
    },
    tips: '食用前可用盐水浸泡，减少过敏反应。',
  },
  {
    id: 'kiwi',
    name: '猕猴桃',
    alias: '奇异果',
    season: '秋季',
    origin: '中国',
    image: 'kiwi.svg',
    nutrition: {
      calories: '41 kcal',
      vitaminC: '92.7 mg',
      fiber: '2.1 g',
      potassium: '312 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '维生素C含量极高。' },
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '护眼', description: '含有叶黄素，有益视力。' },
    ],
    suitability: {
      suitable: '免疫力低下、便秘人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '带皮食用营养更全面，但需清洗干净。',
  },
  {
    id: 'mango',
    name: '芒果',
    alias: '热带果王',
    season: '夏季',
    origin: '南亚',
    image: 'mango.svg',
    nutrition: {
      calories: '60 kcal',
      vitaminA: '54 mcg',
      vitaminC: '36.4 mg',
      fiber: '1.6 g',
    },
    benefits: [
      { category: '护眼', description: '富含维生素A，有益视力。' },
      { category: '增强免疫力', description: '维生素C丰富。' },
      { category: '助消化', description: '含有多种酶，有助于消化。' },
    ],
    suitability: {
      suitable: '视力疲劳、免疫力低下者。',
      unsuitable: '过敏体质、湿疹患者慎食。',
    },
    tips: '芒果易过敏，首次食用应少量尝试。',
  },
  {
    id: 'strawberry',
    name: '草莓',
    alias: '莓王',
    season: '春季',
    origin: '欧洲',
    image: 'strawberry.svg',
    nutrition: {
      calories: '32 kcal',
      vitaminC: '58.8 mg',
      manganese: '0.4 mg',
      fiber: '2 g',
    },
    benefits: [
      { category: '美白护肤', description: '富含维生素C，有助于美白。' },
      { category: '抗氧化', description: '含有多种抗氧化物。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '爱美人士、消化不良者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '草莓表面易残留农药，需充分清洗。',
  },
  {
    id: 'cherry',
    name: '樱桃',
    alias: '车厘子',
    season: '夏季',
    origin: '欧洲、亚洲',
    image: 'cherry.svg',
    nutrition: {
      calories: '50 kcal',
      vitaminC: '7 mg',
      potassium: '173 mg',
      anthocyanins: '丰富',
    },
    benefits: [
      { category: '补血养颜', description: '含铁丰富，有助于补血。' },
      { category: '抗炎', description: '含有花青素，有助于抗炎。' },
      { category: '助眠', description: '含有褪黑素，有助于改善睡眠。' },
    ],
    suitability: {
      suitable: '贫血、失眠人群。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '樱桃易腐烂，需冷藏保存。',
  },
  {
    id: 'lemon',
    name: '柠檬',
    alias: '益母果',
    season: '全年',
    origin: '印度',
    image: 'lemon.svg',
    nutrition: {
      calories: '29 kcal',
      vitaminC: '53 mg',
      citricAcid: '丰富',
      fiber: '2.8 g',
    },
    benefits: [
      { category: '美白养颜', description: '富含维生素C，有助于美白。' },
      { category: '促进消化', description: '柠檬酸有助于消化。' },
      { category: '抗氧化', description: '含有多种抗氧化物。' },
    ],
    suitability: {
      suitable: '爱美人士、消化不良者。',
      unsuitable: '胃酸过多者慎食。',
    },
    tips: '可泡水饮用，清新提神。',
  },
  {
    id: 'peach',
    name: '桃子',
    alias: '寿桃',
    season: '夏季',
    origin: '中国',
    image: 'peach.svg',
    nutrition: {
      calories: '39 kcal',
      vitaminC: '6.6 mg',
      potassium: '190 mg',
      fiber: '1.5 g',
    },
    benefits: [
      { category: '补血养颜', description: '含铁丰富，有助于补血。' },
      { category: '润肠通便', description: '膳食纤维有助于肠道健康。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '贫血、便秘人群。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '桃子易腐烂，建议现吃现买。',
  },
  {
    id: 'pomegranate',
    name: '石榴',
    alias: '安石榴',
    season: '秋季',
    origin: '伊朗、印度',
    image: 'pomegranate.svg',
    nutrition: {
      calories: '83 kcal',
      vitaminC: '10.2 mg',
      potassium: '236 mg',
      polyphenols: '丰富',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚，有助于抗衰老。' },
      { category: '护心', description: '有助于降低胆固醇。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '爱美人士、心血管疾病患者。',
      unsuitable: '便秘者慎食。',
    },
    tips: '石榴汁易染色，食用时注意衣物。',
  },
  {
    id: 'blueberry',
    name: '蓝莓',
    alias: '越橘',
    season: '夏季',
    origin: '北美',
    image: 'blueberry.svg',
    nutrition: {
      calories: '57 kcal',
      vitaminC: '9.7 mg',
      fiber: '2.4 g',
      antioxidants: '花青素',
    },
    benefits: [
      { category: '护眼', description: '富含花青素，有助于保护视力。' },
      { category: '抗氧化', description: '有助于延缓衰老。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '用眼过度、免疫力低下者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '冷冻蓝莓可长期保存，营养损失小。',
  },
  {
    id: 'plum',
    name: '李子',
    alias: '嘉应子',
    season: '夏季',
    origin: '中国',
    image: 'plum.svg',
    nutrition: {
      calories: '46 kcal',
      vitaminC: '9.5 mg',
      fiber: '1.4 g',
      potassium: '157 mg',
    },
    benefits: [
      { category: '润肠通便', description: '富含膳食纤维，有助于消化。' },
      { category: '抗氧化', description: '含有多酚和维生素C。' },
      { category: '降火', description: '性凉，有助于清热。' },
    ],
    suitability: {
      suitable: '便秘、上火人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '李子不宜空腹食用，易引起胃痛。',
  },
  {
    id: 'apricot',
    name: '杏',
    alias: '甜杏',
    season: '夏季',
    origin: '中国、西亚',
    image: 'apricot.svg',
    nutrition: {
      calories: '48 kcal',
      vitaminA: '96 mcg',
      vitaminC: '10 mg',
      fiber: '2 g',
    },
    benefits: [
      { category: '护眼', description: '富含维生素A，有益视力。' },
      { category: '润肺止咳', description: '有助于缓解咳嗽。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '视力疲劳、皮肤干燥者。',
      unsuitable: '孕妇慎食。',
    },
    tips: '杏仁含有微量氢氰酸，不宜多食。',
  },
  {
    id: 'fig',
    name: '无花果',
    alias: '蜜果',
    season: '夏秋',
    origin: '地中海地区',
    image: 'fig.svg',
    nutrition: {
      calories: '74 kcal',
      fiber: '2.9 g',
      calcium: '35 mg',
      potassium: '232 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维和酶。' },
      { category: '补钙', description: '含有一定量的钙。' },
      { category: '润肠通便', description: '有助于缓解便秘。' },
    ],
    suitability: {
      suitable: '消化不良、便秘人群。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '新鲜无花果比干果更易消化。',
  },
  {
    id: 'coconut',
    name: '椰子',
    alias: '椰果',
    season: '全年',
    origin: '热带地区',
    image: 'coconut.svg',
    nutrition: {
      calories: '354 kcal',
      fat: '33 g',
      fiber: '9 g',
      potassium: '356 mg',
    },
    benefits: [
      { category: '补充能量', description: '富含脂肪和碳水化合物。' },
      { category: '补水', description: '椰汁富含电解质。' },
      { category: '助消化', description: '含有丰富膳食纤维。' },
    ],
    suitability: {
      suitable: '运动后补水、能量补充。',
      unsuitable: '高脂血症患者慎食。',
    },
    tips: '椰肉热量高，适量食用。',
  },
  {
    id: 'dragonfruit',
    name: '火龙果',
    alias: '红龙果',
    season: '夏秋',
    origin: '中美洲',
    image: 'dragonfruit.svg',
    nutrition: {
      calories: '50 kcal',
      fiber: '1.5 g',
      vitaminC: '3 mg',
      magnesium: '10 mg',
    },
    benefits: [
      { category: '润肠通便', description: '富含膳食纤维。' },
      { category: '抗氧化', description: '含有多种抗氧化物。' },
      { category: '降火', description: '性凉，有助于清热。' },
    ],
    suitability: {
      suitable: '便秘、上火人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '红心火龙果易染色，食用时注意。',
  },
  {
    id: 'avocado',
    name: '牛油果',
    alias: '鳄梨',
    season: '全年',
    origin: '中美洲',
    image: 'avocado.svg',
    nutrition: {
      calories: '160 kcal',
      fat: '15 g',
      fiber: '7 g',
      potassium: '485 mg',
    },
    benefits: [
      { category: '护心', description: '富含不饱和脂肪酸，有益心血管健康。' },
      { category: '美容养颜', description: '含有多种维生素和抗氧化物。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '心血管疾病患者、爱美人士。',
      unsuitable: '肥胖者慎食。',
    },
    tips: '牛油果成熟后口感更佳，可做沙拉。',
  },
  {
    id: 'papaya',
    name: '木瓜',
    alias: '番木瓜',
    season: '夏秋',
    origin: '中美洲',
    image: 'papaya.svg',
    nutrition: {
      calories: '43 kcal',
      vitaminC: '60.9 mg',
      vitaminA: '47 mcg',
      fiber: '1.7 g',
    },
    benefits: [
      { category: '助消化', description: '含有木瓜酶，有助于分解蛋白质。' },
      { category: '美容养颜', description: '富含维生素C和A。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '孕妇慎食。',
    },
    tips: '木瓜可生食或炖汤。',
  },
  {
    id: 'persimmon',
    name: '柿子',
    alias: '甜柿',
    season: '秋季',
    origin: '中国',
    image: 'persimmon.svg',
    nutrition: {
      calories: '70 kcal',
      vitaminA: '81 mcg',
      vitaminC: '7.5 mg',
      fiber: '3.6 g',
    },
    benefits: [
      { category: '润肺止咳', description: '有助于缓解咳嗽和喉咙干燥。' },
      { category: '美容养颜', description: '富含维生素A和C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '咳嗽、皮肤干燥人群。',
      unsuitable: '空腹及糖尿病患者慎食。',
    },
    tips: '柿子不宜与高蛋白食物同食。',
  },
  {
    id: 'lychee',
    name: '荔枝',
    alias: '妃子笑',
    season: '夏季',
    origin: '中国',
    image: 'lychee.svg',
    nutrition: {
      calories: '66 kcal',
      vitaminC: '71.5 mg',
      fiber: '1.3 g',
      potassium: '171 mg',
    },
    benefits: [
      { category: '补血养颜', description: '富含维生素C和铁。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '补充能量', description: '糖分含量高，能快速补充体力。' },
    ],
    suitability: {
      suitable: '贫血、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '荔枝性温，易上火，适量食用。',
  },
  {
    id: 'longan',
    name: '龙眼',
    alias: '桂圆',
    season: '夏秋',
    origin: '中国',
    image: 'longan.svg',
    nutrition: {
      calories: '60 kcal',
      vitaminC: '84 mg',
      potassium: '266 mg',
      iron: '0.13 mg',
    },
    benefits: [
      { category: '补血安神', description: '有助于缓解失眠和贫血。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '失眠、贫血、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '龙眼干可泡水或煲汤。',
  },
  {
    id: 'starfruit',
    name: '杨桃',
    alias: '五棱果',
    season: '秋冬',
    origin: '东南亚',
    image: 'starfruit.svg',
    nutrition: {
      calories: '31 kcal',
      vitaminC: '34.4 mg',
      fiber: '2.8 g',
      potassium: '133 mg',
    },
    benefits: [
      { category: '清热解毒', description: '性凉，有助于降火。' },
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '美容养颜', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '上火、消化不良人群。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '杨桃可生食或榨汁。',
  },
  {
    id: 'jackfruit',
    name: '菠萝蜜',
    alias: '树菠萝',
    season: '夏秋',
    origin: '南亚',
    image: 'jackfruit.svg',
    nutrition: {
      calories: '95 kcal',
      vitaminC: '13.7 mg',
      fiber: '1.5 g',
      potassium: '448 mg',
    },
    benefits: [
      { category: '补充能量', description: '富含碳水化合物和糖分。' },
      { category: '助消化', description: '含有膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、免疫力低下者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '菠萝蜜果肉可直接食用或做甜品。',
  },
  {
    id: 'durian',
    name: '榴莲',
    alias: '水果之王',
    season: '夏季',
    origin: '东南亚',
    image: 'durian.svg',
    nutrition: {
      calories: '147 kcal',
      fat: '5.3 g',
      fiber: '3.8 g',
      vitaminC: '19.7 mg',
    },
    benefits: [
      { category: '补充能量', description: '高热量，适合体力消耗大者。' },
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、免疫力低下者。',
      unsuitable: '高血压、糖尿病患者慎食。',
    },
    tips: '榴莲气味浓烈，适量食用。',
  },
  {
    id: 'melon',
    name: '哈密瓜',
    alias: '甜瓜',
    season: '夏季',
    origin: '中国',
    image: 'melon.svg',
    nutrition: {
      calories: '34 kcal',
      vitaminC: '36.7 mg',
      fiber: '0.9 g',
      potassium: '267 mg',
    },
    benefits: [
      { category: '补水解暑', description: '高含水量，有助于补充水分。' },
      { category: '助消化', description: '含有膳食纤维。' },
      { category: '美容养颜', description: '富含维生素C。' },
    ],
    suitability: {
      suitable: '夏季消暑、皮肤干燥者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '哈密瓜宜现切现吃，易变质。',
  },
  {
    id: 'cranberry',
    name: '蔓越莓',
    alias: '小红莓',
    season: '秋季',
    origin: '北美',
    image: 'cranberry.svg',
    nutrition: {
      calories: '46 kcal',
      vitaminC: '13.3 mg',
      fiber: '3.6 g',
      antioxidants: '花青素',
    },
    benefits: [
      { category: '泌尿健康', description: '有助于预防尿路感染。' },
      { category: '抗氧化', description: '富含花青素。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '女性、免疫力低下者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '蔓越莓干可作为零食或烘焙原料。',
  },
  {
    id: 'passionfruit',
    name: '百香果',
    alias: '鸡蛋果',
    season: '夏秋',
    origin: '南美洲',
    image: 'passionfruit.svg',
    nutrition: {
      calories: '97 kcal',
      vitaminC: '30 mg',
      fiber: '10.4 g',
      potassium: '348 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '美容养颜', description: '富含抗氧化物。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '百香果可直接食用或泡水。',
  },
  {
    id: 'mulberry',
    name: '桑葚',
    alias: '桑果',
    season: '春夏',
    origin: '中国',
    image: 'mulberry.svg',
    nutrition: {
      calories: '43 kcal',
      vitaminC: '36.4 mg',
      fiber: '1.7 g',
      iron: '1.9 mg',
    },
    benefits: [
      { category: '补血养颜', description: '富含铁和维生素C。' },
      { category: '抗氧化', description: '含有多种抗氧化物。' },
      { category: '润肠通便', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '贫血、便秘人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '桑葚易染色，食用时注意衣物。',
  },
  {
    id: 'date',
    name: '红枣',
    alias: '大枣',
    season: '秋季',
    origin: '中国',
    image: 'date.svg',
    nutrition: {
      calories: '79 kcal',
      vitaminC: '69 mg',
      fiber: '0.6 g',
      potassium: '250 mg',
    },
    benefits: [
      { category: '补血养颜', description: '富含铁和维生素C。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '助眠安神', description: '有助于改善睡眠。' },
    ],
    suitability: {
      suitable: '贫血、失眠人群。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '红枣可煲汤、泡茶或直接食用。',
  },
  {
    id: 'blackberry',
    name: '黑莓',
    alias: '覆盆子',
    season: '夏季',
    origin: '欧洲、北美',
    image: 'blackberry.svg',
    nutrition: {
      calories: '43 kcal',
      vitaminC: '21 mg',
      fiber: '5.3 g',
      manganese: '0.6 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含花青素，有助于延缓衰老。' },
      { category: '护眼', description: '有助于保护视力。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '用眼过度、免疫力低下者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '黑莓可直接食用或做果酱。',
  },
  {
    id: 'raspberry',
    name: '红莓',
    alias: '覆盆子',
    season: '夏季',
    origin: '欧洲、北美',
    image: 'raspberry.svg',
    nutrition: {
      calories: '52 kcal',
      vitaminC: '26.2 mg',
      fiber: '6.5 g',
      manganese: '0.7 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '爱美人士、消化不良者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '红莓可做甜品或果酱。',
  },
  {
    id: 'currant',
    name: '黑加仑',
    alias: '黑醋栗',
    season: '夏季',
    origin: '欧洲',
    image: 'currant.svg',
    nutrition: {
      calories: '63 kcal',
      vitaminC: '181 mg',
      fiber: '4.3 g',
      potassium: '322 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '维生素C含量极高。' },
      { category: '抗氧化', description: '富含多酚。' },
      { category: '护眼', description: '有助于保护视力。' },
    ],
    suitability: {
      suitable: '免疫力低下、用眼过度者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '黑加仑可做果汁或果酱。',
  },
  {
    id: 'gooseberry',
    name: '醋栗',
    alias: '灯笼果',
    season: '夏季',
    origin: '欧洲、亚洲',
    image: 'gooseberry.svg',
    nutrition: {
      calories: '44 kcal',
      vitaminC: '27.7 mg',
      fiber: '4.3 g',
      potassium: '198 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含维生素C和多酚。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '护肝', description: '有助于肝脏健康。' },
    ],
    suitability: {
      suitable: '消化不良、肝功能欠佳者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '醋栗可直接食用或做果酱。',
  },
  {
    id: 'tangerine',
    name: '橘子',
    alias: '蜜橘',
    season: '秋冬',
    origin: '中国',
    image: 'tangerine.svg',
    nutrition: {
      calories: '53 kcal',
      vitaminC: '26.7 mg',
      fiber: '1.8 g',
      potassium: '166 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '润肺止咳', description: '有助于缓解咳嗽。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '免疫力低下、咳嗽人群。',
      unsuitable: '胃酸过多者慎食。',
    },
    tips: '橘皮可泡水饮用。',
  },
  {
    id: 'pomelo',
    name: '柚子',
    alias: '文旦',
    season: '秋冬',
    origin: '中国',
    image: 'pomelo.svg',
    nutrition: {
      calories: '38 kcal',
      vitaminC: '61 mg',
      fiber: '1 g',
      potassium: '216 mg',
    },
    benefits: [
      { category: '降血脂', description: '有助于降低胆固醇。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '高血脂、免疫力低下者。',
      unsuitable: '胃寒者慎食。',
    },
    tips: '柚子可直接食用或榨汁。',
  },
  {
    id: 'loquat',
    name: '枇杷',
    alias: '芦橘',
    season: '春夏',
    origin: '中国',
    image: 'loquat.svg',
    nutrition: {
      calories: '47 kcal',
      vitaminA: '76 mcg',
      vitaminC: '1 mg',
      potassium: '266 mg',
    },
    benefits: [
      { category: '润肺止咳', description: '有助于缓解咳嗽和喉咙干燥。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '富含维生素A。' },
    ],
    suitability: {
      suitable: '咳嗽、消化不良人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '枇杷可生食或炖汤。',
  },
  {
    id: 'olive',
    name: '橄榄',
    alias: '青果',
    season: '秋季',
    origin: '地中海地区',
    image: 'olive.svg',
    nutrition: {
      calories: '115 kcal',
      fat: '10.7 g',
      vitaminE: '3.8 mg',
      iron: '0.6 mg',
    },
    benefits: [
      { category: '护心', description: '富含不饱和脂肪酸。' },
      { category: '抗氧化', description: '含有多酚和维生素E。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '心血管疾病患者、爱美人士。',
      unsuitable: '高脂血症患者慎食。',
    },
    tips: '橄榄油为健康食用油。',
  },
  {
    id: 'sugarapple',
    name: '番荔枝',
    alias: '释迦果',
    season: '夏秋',
    origin: '南美洲',
    image: 'sugarapple.svg',
    nutrition: {
      calories: '94 kcal',
      vitaminC: '36.3 mg',
      fiber: '2.4 g',
      potassium: '247 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '番荔枝果肉软糯香甜。',
  },
  {
    id: 'sapodilla',
    name: '人心果',
    alias: '牛奶果',
    season: '春夏',
    origin: '中美洲',
    image: 'sapodilla.svg',
    nutrition: {
      calories: '83 kcal',
      vitaminC: '14.7 mg',
      fiber: '5.3 g',
      potassium: '193 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高，能快速补充体力。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '富含多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '人心果果肉细腻香甜。',
  },
  {
    id: 'tamarind',
    name: '罗望子',
    alias: '酸角',
    season: '春夏',
    origin: '非洲、南亚',
    image: 'tamarind.svg',
    nutrition: {
      calories: '239 kcal',
      vitaminC: '3.5 mg',
      fiber: '5.1 g',
      potassium: '628 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维和有机酸。' },
      { category: '补充能量', description: '糖分含量高。' },
      { category: '抗氧化', description: '含有多酚。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '罗望子常用于饮料和调味品。',
  },
  {
    id: 'soursop',
    name: '刺果番荔枝',
    alias: '番荔枝',
    season: '夏秋',
    origin: '南美洲',
    image: 'soursop.svg',
    nutrition: {
      calories: '66 kcal',
      vitaminC: '20.6 mg',
      fiber: '3.3 g',
      potassium: '278 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '抗氧化', description: '含有多酚。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '刺果番荔枝果肉柔软多汁。',
  },
  {
    id: 'physalis',
    name: '灯笼果',
    alias: '酸浆果',
    season: '夏秋',
    origin: '南美洲',
    image: 'physalis.svg',
    nutrition: {
      calories: '53 kcal',
      vitaminC: '11 mg',
      fiber: '1.9 g',
      potassium: '268 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '消化不良、免疫力低下者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '灯笼果可直接食用或做果酱。',
  },
  {
    id: 'medlar',
    name: '枸杞',
    alias: '宁夏枸杞',
    season: '夏秋',
    origin: '中国',
    image: 'medlar.svg',
    nutrition: {
      calories: '349 kcal',
      vitaminC: '48.4 mg',
      fiber: '13 g',
      iron: '6.8 mg',
    },
    benefits: [
      { category: '护眼', description: '富含胡萝卜素和维生素A。' },
      { category: '补血养颜', description: '含有铁和多种维生素。' },
      { category: '增强免疫力', description: '有助于提高免疫力。' },
    ],
    suitability: {
      suitable: '视力疲劳、贫血、免疫力低下者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '枸杞可泡水、煲汤或直接食用。',
  },
  {
    id: 'mangosteen',
    name: '山竹',
    alias: '莽吉柿',
    season: '夏秋',
    origin: '东南亚',
    image: 'mangosteen.svg',
    nutrition: {
      calories: '73 kcal',
      vitaminC: '2.9 mg',
      fiber: '1.8 g',
      potassium: '48 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚，有助于延缓衰老。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '爱美人士、免疫力低下者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '山竹果肉洁白，口感细腻。',
  },
  {
    id: 'carambola',
    name: '杨桃',
    alias: '五棱果',
    season: '秋冬',
    origin: '东南亚',
    image: 'carambola.svg',
    nutrition: {
      calories: '31 kcal',
      vitaminC: '34.4 mg',
      fiber: '2.8 g',
      potassium: '133 mg',
    },
    benefits: [
      { category: '清热解毒', description: '性凉，有助于降火。' },
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '美容养颜', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '上火、消化不良人群。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '杨桃可生食或榨汁。',
  },
  {
    id: 'salak',
    name: '蛇皮果',
    alias: '沙叻',
    season: '夏秋',
    origin: '东南亚',
    image: 'salak.svg',
    nutrition: {
      calories: '82 kcal',
      vitaminC: '8.4 mg',
      fiber: '2.6 g',
      potassium: '256 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '补充能量', description: '糖分含量高。' },
      { category: '抗氧化', description: '含有多酚。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '蛇皮果果皮粗糙，果肉脆甜。',
  },
  {
    id: 'langsat',
    name: '龙贡果',
    alias: '兰撒',
    season: '夏秋',
    origin: '东南亚',
    image: 'langsat.svg',
    nutrition: {
      calories: '57 kcal',
      vitaminC: '2 mg',
      fiber: '1.5 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '免疫力低下、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '龙贡果果肉多汁，味道清甜。',
  },
  {
    id: 'longkong',
    name: '龙宫果',
    alias: '龙眼兰撒',
    season: '夏秋',
    origin: '东南亚',
    image: 'longkong.svg',
    nutrition: {
      calories: '57 kcal',
      vitaminC: '2 mg',
      fiber: '1.5 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '免疫力低下、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '龙宫果果肉多汁，味道清甜。',
  },
  {
    id: 'miraclefruit',
    name: '神秘果',
    alias: '变味果',
    season: '全年',
    origin: '西非',
    image: 'miraclefruit.svg',
    nutrition: {
      calories: '30 kcal',
      vitaminC: '2 mg',
      fiber: '1.5 g',
      miraculin: '丰富',
    },
    benefits: [
      { category: '味觉改变', description: '含有神奇的味觉蛋白miraculin。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '味觉体验、消化不良者。',
      unsuitable: '孕妇慎食。',
    },
    tips: '神秘果可让酸味变甜。',
  },
  {
    id: 'breadfruit',
    name: '面包果',
    alias: '木波罗',
    season: '夏秋',
    origin: '太平洋群岛',
    image: 'breadfruit.svg',
    nutrition: {
      calories: '103 kcal',
      vitaminC: '29 mg',
      fiber: '4.9 g',
      potassium: '490 mg',
    },
    benefits: [
      { category: '补充能量', description: '富含碳水化合物。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '面包果可蒸煮或烘烤食用。',
  },
  {
    id: 'cherimoya',
    name: '番荔枝',
    alias: '释迦果',
    season: '夏秋',
    origin: '南美洲',
    image: 'cherimoya.svg',
    nutrition: {
      calories: '75 kcal',
      vitaminC: '12.6 mg',
      fiber: '3 g',
      potassium: '287 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '番荔枝果肉软糯香甜。',
  },
  {
    id: 'rambutan',
    name: '红毛丹',
    alias: '毛荔枝',
    season: '夏秋',
    origin: '东南亚',
    image: 'rambutan.svg',
    nutrition: {
      calories: '68 kcal',
      vitaminC: '8.5 mg',
      fiber: '0.9 g',
      potassium: '42 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '红毛丹果肉多汁，味道清甜。',
  },
  {
    id: 'pulasan',
    name: '普拉桑',
    alias: '甜红毛丹',
    season: '夏秋',
    origin: '东南亚',
    image: 'pulasan.svg',
    nutrition: {
      calories: '82 kcal',
      vitaminC: '8.4 mg',
      fiber: '2.6 g',
      potassium: '256 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '普拉桑果肉多汁，味道清甜。',
  },
  {
    id: 'ackee',
    name: '阿开木',
    alias: '西非荔枝',
    season: '夏秋',
    origin: '西非',
    image: 'ackee.svg',
    nutrition: {
      calories: '151 kcal',
      vitaminC: '30 mg',
      fiber: '2.7 g',
      potassium: '270 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '未熟果实有毒，需谨慎食用。',
    },
    tips: '阿开木果实需完全成熟后食用。',
  },
  {
    id: 'feijoa',
    name: '费约果',
    alias: '菠萝番石榴',
    season: '秋季',
    origin: '南美洲',
    image: 'feijoa.svg',
    nutrition: {
      calories: '55 kcal',
      vitaminC: '32.9 mg',
      fiber: '6.4 g',
      potassium: '172 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '费约果果肉多汁，味道独特。',
  },
  {
    id: 'pawpaw',
    name: '北美番木瓜',
    alias: '美洲木瓜',
    season: '秋季',
    origin: '北美',
    image: 'pawpaw.svg',
    nutrition: {
      calories: '80 kcal',
      vitaminC: '18.3 mg',
      fiber: '2.6 g',
      potassium: '345 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '北美番木瓜果肉柔软香甜。',
  },
  {
    id: 'santol',
    name: '山多士果',
    alias: '棉果',
    season: '夏秋',
    origin: '东南亚',
    image: 'santol.svg',
    nutrition: {
      calories: '88 kcal',
      vitaminC: '9.2 mg',
      fiber: '3.9 g',
      potassium: '149 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '山多士果果肉多汁，味道酸甜。',
  },
  {
    id: 'lucuma',
    name: '卢库马果',
    alias: '蛋黄果',
    season: '秋季',
    origin: '南美洲',
    image: 'lucuma.svg',
    nutrition: {
      calories: '99 kcal',
      vitaminC: '2.2 mg',
      fiber: '2.3 g',
      potassium: '490 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '卢库马果果肉细腻，味道独特。',
  },
  {
    id: 'cupuacu',
    name: '古布阿苏果',
    alias: '巴西亚马逊果',
    season: '夏秋',
    origin: '南美洲',
    image: 'cupuacu.svg',
    nutrition: {
      calories: '65 kcal',
      vitaminC: '24 mg',
      fiber: '2.4 g',
      potassium: '292 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '古布阿苏果果肉可做饮料和甜品。',
  },
  {
    id: 'bael',
    name: '木橘',
    alias: '贝尔果',
    season: '夏秋',
    origin: '南亚',
    image: 'bael.svg',
    nutrition: {
      calories: '137 kcal',
      vitaminC: '8 mg',
      fiber: '2.9 g',
      potassium: '218 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '木橘果肉可做饮料和甜品。',
  },
  {
    id: 'safou',
    name: '非洲梨',
    alias: '奶油果',
    season: '夏秋',
    origin: '非洲',
    image: 'safou.svg',
    nutrition: {
      calories: '220 kcal',
      vitaminC: '29 mg',
      fiber: '5.2 g',
      potassium: '337 mg',
    },
    benefits: [
      { category: '补充能量', description: '脂肪含量高，能量丰富。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '肥胖者慎食。',
    },
    tips: '非洲梨果肉细腻，味道独特。',
  },
  {
    id: 'tangelo',
    name: '唐柚',
    alias: '蜜柚',
    season: '冬季',
    origin: '美国',
    image: 'tangelo.svg',
    nutrition: {
      calories: '47 kcal',
      vitaminC: '50 mg',
      fiber: '1.7 g',
      potassium: '166 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '胃酸过多者慎食。',
    },
    tips: '唐柚可直接食用或榨汁。',
  },
  {
    id: 'ugli',
    name: '丑橘',
    alias: '丑柑',
    season: '冬春',
    origin: '牙买加',
    image: 'ugli.svg',
    nutrition: {
      calories: '45 kcal',
      vitaminC: '70 mg',
      fiber: '2 g',
      potassium: '181 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '胃酸过多者慎食。',
    },
    tips: '丑橘果皮粗糙，果肉多汁。',
  },
  {
    id: 'yumberry',
    name: '杨梅',
    alias: '红梅',
    season: '夏季',
    origin: '中国',
    image: 'yumberry.svg',
    nutrition: {
      calories: '28 kcal',
      vitaminC: '41 mg',
      fiber: '1.1 g',
      potassium: '114 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '杨梅果肉多汁，味道酸甜。',
  },
  {
    id: 'whitecurrant',
    name: '白加仑',
    alias: '白醋栗',
    season: '夏季',
    origin: '欧洲',
    image: 'whitecurrant.svg',
    nutrition: {
      calories: '56 kcal',
      vitaminC: '41 mg',
      fiber: '4.3 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '抗氧化', description: '含有多酚。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '白加仑可做果酱或甜品。',
  },
  {
    id: 'redcurrant',
    name: '红加仑',
    alias: '红醋栗',
    season: '夏季',
    origin: '欧洲',
    image: 'redcurrant.svg',
    nutrition: {
      calories: '56 kcal',
      vitaminC: '41 mg',
      fiber: '4.3 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '抗氧化', description: '含有多酚。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '红加仑可做果酱或甜品。',
  },
  {
    id: 'mulberryfig',
    name: '桑椹无花果',
    alias: '桑葚无花果',
    season: '夏秋',
    origin: '中国',
    image: 'mulberryfig.svg',
    nutrition: {
      calories: '45 kcal',
      vitaminC: '10 mg',
      fiber: '2.5 g',
      potassium: '200 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '补血养颜', description: '富含铁和维生素C。' },
    ],
    suitability: {
      suitable: '贫血、消化不良者。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '桑椹无花果果肉多汁，味道独特。',
  },
  {
    id: 'soursopfig',
    name: '刺果无花果',
    alias: '刺无花果',
    season: '夏秋',
    origin: '南美洲',
    image: 'soursopfig.svg',
    nutrition: {
      calories: '60 kcal',
      vitaminC: '15 mg',
      fiber: '3.2 g',
      potassium: '210 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '刺果无花果果肉柔软多汁。',
  },
  {
    id: 'kiwano',
    name: '非洲角瓜',
    alias: '刺角瓜',
    season: '夏秋',
    origin: '非洲',
    image: 'kiwano.svg',
    nutrition: {
      calories: '44 kcal',
      vitaminC: '5.3 mg',
      fiber: '1.1 g',
      potassium: '123 mg',
    },
    benefits: [
      { category: '补水解暑', description: '高含水量，有助于补充水分。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '夏季消暑、免疫力低下者。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '非洲角瓜果肉多汁，味道独特。',
  },
  {
    id: 'pitaya',
    name: '黄龙果',
    alias: '黄皮火龙果',
    season: '夏秋',
    origin: '中美洲',
    image: 'pitaya.svg',
    nutrition: {
      calories: '50 kcal',
      vitaminC: '3 mg',
      fiber: '1.5 g',
      magnesium: '10 mg',
    },
    benefits: [
      { category: '润肠通便', description: '富含膳食纤维。' },
      { category: '抗氧化', description: '含有多种抗氧化物。' },
      { category: '降火', description: '性凉，有助于清热。' },
    ],
    suitability: {
      suitable: '便秘、上火人群。',
      unsuitable: '脾胃虚寒者慎食。',
    },
    tips: '黄龙果果肉柔软多汁。',
  },
  {
    id: 'tamarillo',
    name: '树番茄',
    alias: '番茄果',
    season: '夏秋',
    origin: '南美洲',
    image: 'tamarillo.svg',
    nutrition: {
      calories: '31 kcal',
      vitaminC: '29 mg',
      fiber: '1.3 g',
      potassium: '321 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '树番茄果肉多汁，味道独特。',
  },
  {
    id: 'noni',
    name: '诺丽果',
    alias: '海巴戟',
    season: '全年',
    origin: '东南亚',
    image: 'noni.svg',
    nutrition: {
      calories: '47 kcal',
      vitaminC: '21 mg',
      fiber: '2.1 g',
      potassium: '150 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '抗氧化', description: '含有多酚。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '孕妇慎食。',
    },
    tips: '诺丽果果肉多汁，味道独特。',
  },
  {
    id: 'santolfig',
    name: '山多士无花果',
    alias: '棉无花果',
    season: '夏秋',
    origin: '东南亚',
    image: 'santolfig.svg',
    nutrition: {
      calories: '60 kcal',
      vitaminC: '10 mg',
      fiber: '2.5 g',
      potassium: '180 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚和维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '山多士无花果果肉多汁，味道独特。',
  },
  {
    id: 'cempedak',
    name: '菠萝蜜楔',
    alias: '楔形菠萝蜜',
    season: '夏秋',
    origin: '东南亚',
    image: 'cempedak.svg',
    nutrition: {
      calories: '95 kcal',
      vitaminC: '13.7 mg',
      fiber: '1.5 g',
      potassium: '448 mg',
    },
    benefits: [
      { category: '补充能量', description: '富含碳水化合物和糖分。' },
      { category: '助消化', description: '含有膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、免疫力低下者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '菠萝蜜楔果肉可直接食用或做甜品。',
  },
  {
    id: 'sugarfig',
    name: '甜无花果',
    alias: '蜜无花果',
    season: '夏秋',
    origin: '地中海地区',
    image: 'sugarfig.svg',
    nutrition: {
      calories: '74 kcal',
      vitaminC: '2 mg',
      fiber: '2.9 g',
      potassium: '232 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维和酶。' },
      { category: '补钙', description: '含有一定量的钙。' },
      { category: '润肠通便', description: '有助于缓解便秘。' },
    ],
    suitability: {
      suitable: '消化不良、便秘人群。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '甜无花果果肉多汁，味道独特。',
  },
  {
    id: 'sweetsop',
    name: '番荔枝果',
    alias: '甜番荔枝',
    season: '夏秋',
    origin: '南美洲',
    image: 'sweetsop.svg',
    nutrition: {
      calories: '94 kcal',
      vitaminC: '36.3 mg',
      fiber: '2.4 g',
      potassium: '247 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '番荔枝果果肉软糯香甜。',
  },
  {
    id: 'jabuticaba',
    name: '嘉宝果',
    alias: '巴西葡萄',
    season: '春夏',
    origin: '巴西',
    image: 'jabuticaba.svg',
    nutrition: {
      calories: '45 kcal',
      vitaminC: '27 mg',
      fiber: '2.3 g',
      potassium: '180 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含花青素和多酚。' },
      { category: '增强免疫力', description: '含有丰富维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '肾功能不全者慎食。',
    },
    tips: '嘉宝果可直接食用或做果酱。',
  },
  {
    id: 'santol',
    name: '山多士果',
    alias: '棉果',
    season: '夏秋',
    origin: '东南亚',
    image: 'santol.svg',
    nutrition: {
      calories: '88 kcal',
      vitaminC: '9.2 mg',
      fiber: '3.9 g',
      potassium: '149 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '山多士果果肉多汁，味道酸甜。',
  },
  {
    id: 'lucuma',
    name: '卢库马果',
    alias: '蛋黄果',
    season: '秋季',
    origin: '南美洲',
    image: 'lucuma.svg',
    nutrition: {
      calories: '99 kcal',
      vitaminC: '2.2 mg',
      fiber: '2.3 g',
      potassium: '490 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '卢库马果果肉细腻，味道独特。',
  },
  {
    id: 'cupuacu',
    name: '古布阿苏果',
    alias: '巴西亚马逊果',
    season: '夏秋',
    origin: '南美洲',
    image: 'cupuacu.svg',
    nutrition: {
      calories: '65 kcal',
      vitaminC: '24 mg',
      fiber: '2.4 g',
      potassium: '292 mg',
    },
    benefits: [
      { category: '抗氧化', description: '富含多酚。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
    ],
    suitability: {
      suitable: '免疫力低下、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '古布阿苏果果肉可做饮料和甜品。',
  },
  {
    id: 'bael',
    name: '木橘',
    alias: '贝尔果',
    season: '夏秋',
    origin: '南亚',
    image: 'bael.svg',
    nutrition: {
      calories: '137 kcal',
      vitaminC: '8 mg',
      fiber: '2.9 g',
      potassium: '218 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '木橘果肉可做饮料和甜品。',
  },
  {
    id: 'safou',
    name: '非洲梨',
    alias: '奶油果',
    season: '夏秋',
    origin: '非洲',
    image: 'safou.svg',
    nutrition: {
      calories: '245 kcal',
      vitaminC: '25 mg',
      fiber: '5.2 g',
      potassium: '337 mg',
    },
    benefits: [
      { category: '补充能量', description: '高热量，适合体力消耗大者。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '美容养颜', description: '富含维生素C和E。' },
    ],
    suitability: {
      suitable: '体力消耗大、爱美人士。',
      unsuitable: '肥胖者慎食。',
    },
    tips: '非洲梨果肉细腻，味道独特。',
  },
  {
    id: 'pulasan',
    name: '普拉桑',
    alias: '甜红毛丹',
    season: '夏秋',
    origin: '东南亚',
    image: 'pulasan.svg',
    nutrition: {
      calories: '82 kcal',
      vitaminC: '8.4 mg',
      fiber: '2.6 g',
      potassium: '256 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '普拉桑果肉多汁，味道清甜。',
  },
  {
    id: 'rambutan',
    name: '红毛丹',
    alias: '毛荔枝',
    season: '夏秋',
    origin: '东南亚',
    image: 'rambutan.svg',
    nutrition: {
      calories: '68 kcal',
      vitaminC: '8.5 mg',
      fiber: '0.9 g',
      potassium: '42 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '红毛丹果肉多汁，味道清甜。',
  },
  {
    id: 'longkong',
    name: '龙宫果',
    alias: '龙眼兰撒',
    season: '夏秋',
    origin: '东南亚',
    image: 'longkong.svg',
    nutrition: {
      calories: '57 kcal',
      vitaminC: '2 mg',
      fiber: '1.5 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '免疫力低下、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '龙宫果果肉多汁，味道清甜。',
  },
  {
    id: 'langsat',
    name: '龙贡果',
    alias: '兰撒',
    season: '夏秋',
    origin: '东南亚',
    image: 'langsat.svg',
    nutrition: {
      calories: '57 kcal',
      vitaminC: '2 mg',
      fiber: '1.5 g',
      potassium: '275 mg',
    },
    benefits: [
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '免疫力低下、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '龙贡果果肉多汁，味道清甜。',
  },
  {
    id: 'ackee',
    name: '阿开木',
    alias: '西非荔枝',
    season: '夏秋',
    origin: '西非',
    image: 'ackee.svg',
    nutrition: {
      calories: '151 kcal',
      vitaminC: '30 mg',
      fiber: '2.7 g',
      potassium: '270 mg',
    },
    benefits: [
      { category: '补充能量', description: '糖分含量高。' },
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
    ],
    suitability: {
      suitable: '体力消耗大、消化不良者。',
      unsuitable: '未熟果实有毒，需谨慎食用。',
    },
    tips: '阿开木果实需完全成熟后食用。',
  },
  {
    id: 'feijoa',
    name: '费约果',
    alias: '菠萝番石榴',
    season: '秋季',
    origin: '南美洲',
    image: 'feijoa.svg',
    nutrition: {
      calories: '55 kcal',
      vitaminC: '32.9 mg',
      fiber: '6.4 g',
      potassium: '172 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '费约果果肉多汁，味道独特。',
  },
  {
    id: 'pawpaw',
    name: '北美番木瓜',
    alias: '美洲木瓜',
    season: '秋季',
    origin: '北美',
    image: 'pawpaw.svg',
    nutrition: {
      calories: '80 kcal',
      vitaminC: '18.3 mg',
      fiber: '2.6 g',
      potassium: '345 mg',
    },
    benefits: [
      { category: '助消化', description: '膳食纤维丰富。' },
      { category: '增强免疫力', description: '富含维生素C。' },
      { category: '补充能量', description: '糖分含量高。' },
    ],
    suitability: {
      suitable: '消化不良、体力消耗大者。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '北美番木瓜果肉柔软香甜。',
  },
  {
    id: 'cherimoya',
    name: '番荔枝',
    alias: '释迦果',
    season: '夏秋',
    origin: '南美洲',
    image: 'cherimoya.svg',
    nutrition: {
      calories: '75 kcal',
      vitaminC: '12.6 mg',
      fiber: '3 g',
      potassium: '287 mg',
    },
    benefits: [
      { category: '助消化', description: '富含膳食纤维。' },
      { category: '增强免疫力', description: '含有多种维生素。' },
      { category: '美容养颜', description: '有助于皮肤健康。' },
    ],
    suitability: {
      suitable: '消化不良、爱美人士。',
      unsuitable: '糖尿病患者慎食。',
    },
    tips: '番荔枝果肉软糯香甜。',
  },
];
